const NotificationTypes = {
  ADD_NOTIFICATION: "ADD_NOTIFICATION",
  SET_NOTIFICATIONS: "SET_NOTIFICATIONS",
  MARK_AS_READ: "MARK_AS_READ",
  MARK_AS_READ_START: "MARK_AS_READ_START",
  MARK_AS_READ_SUCCESS: "MARK_AS_READ_SUCCESS",
  MARK_AS_READ_FAILURE: "MARK_AS_READ_FAILURE",
  MARK_ALL_AS_READ: "MARK_ALL_AS_READ",
  CLEAR_NOTIFICATIONS: "CLEAR_NOTIFICATIONS",
  SET_CONNECTION_STATUS: "SET_CONNECTION_STATUS",
  SET_UNREAD_COUNT: "SET_UNREAD_COUNT",
  REMOVE_NOTIFICATION: "REMOVE_NOTIFICATION",
  FETCH_NOTIFICATIONS_START: "FETCH_NOTIFICATIONS_START",
  FETCH_NOTIFICATIONS_SUCCESS: "FETCH_NOTIFICATIONS_SUCCESS",
  FETCH_NOTIFICATIONS_FAILURE: "FETCH_NOTIFICATIONS_FAILURE",
};

export default NotificationTypes;
